import type { MassRetagResponse } from '@modules/mass-retag/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { MASS_RETAG_API_URL, MASS_RETAG_MUTATION_KEY, PLAYERS_MASSTAG_PERMISSIONS } from '@modules/mass-retag/constants';
import { useToastStore } from '@modules/toast/store';

export default function useSettingsAffiliateBannerSaveMutation(): ReturnType<
    typeof useContextMutation<MassRetagResponse, Error, FormData>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    MassRetagResponse,
    Error,
    FormData
  >({
    mutationKey: [MASS_RETAG_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<MassRetagResponse>(
      MASS_RETAG_API_URL,
      payload,
      {
        permission: PLAYERS_MASSTAG_PERMISSIONS.PLAYERS_RETAG,
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
